import React, { useState } from "react";
import { Checkbox, Col, Modal, Row } from "antd";
import BaseButton from "../../Button/BaseButton";
import { useTranslation } from "react-i18next";
import InputText from "../../Input/InputText";
import "../../../../assets/style/modalStyle/postNews.scss";
import { useDispatch, useSelector } from "react-redux";
import { storeProductSelector } from "../../../../services/selector/index.";
import {
  editProduct,
  getDetailProduct,
  setOpenEditProduct,
} from "../../../../services/slice/StoreSlice";
import LabelInput from "../../LabelInput";
import { useEffect } from "react";
import { IconSave } from "../../../../assets/icon";
import UpImageEdit from "../../Button/UpImageEdit";
import { isValidPrice } from "../../../../utils/functionCommon";

const ModalEditProduct = () => {
  const stateStore = useSelector(storeProductSelector);
  const { isOpenModalEdit, detailByID, idProduct } = stateStore;
  const [datapost, setDataPost] = useState({
    name: "",
    descriptions: "",
    content: "",
    price: "",
    priceDrop: "",
    categoryId: "",
    code: "",
    id: "",
    orderLink: "",
    url: "",
  });
  const [error, setError] = useState({
    isError: false,
    msg: "",
  });
  const [valueCheck, setValueCheck] = useState("1");
  const [image, setImage] = useState("");
  const { t } = useTranslation();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getDetailProduct(idProduct));
  }, []);
  useEffect(() => {
    setDataPost({
      name: detailByID.name,
      descriptions: detailByID.descriptions,
      content: detailByID.content,
      price: detailByID.price,
      priceDrop: detailByID.priceDrop,
      categoryId: detailByID.categoryId,
      code: detailByID.code,
      id: detailByID.id,
      orderLink: detailByID.orderLink,
      url: detailByID.urlImage,
      typeButton: detailByID.typeButton,
      detailLink: detailByID.detailLink,
      workCCS: detailByID.workCCS,
      productTypeId: detailByID.productTypeId,
    });
    setValueCheck(detailByID?.typeButton?.toString());
  }, [
    detailByID.workCCS,
    detailByID.productTypeId,
    detailByID.categoryId,
    detailByID.code,
    detailByID.content,
    detailByID.descriptions,
    detailByID.priceDrop,
    detailByID.id,
    detailByID.name,
    detailByID.orderLink,
    detailByID.price,
    detailByID.urlImage,
    detailByID.detailLink,
  ]);
  const handleSave = () => {
    isValidPrice(datapost.price);
    // return;
    if (
      !datapost.name ||
      (!datapost.price && !datapost.priceText) ||
      (parseInt(datapost.typeButton) === 1 && !datapost.orderLink)
    ) {
      setError({
        isError: true,
        msg: "Vui lòng nhập đầy đủ thông tin",
      });
      return;
    }
    if (image.size > 2 * 1024 * 1024) {
      setError({
        isError: true,
        msg: "Dung lượng ảnh phải nhỏ hơn < 2MB",
      });
      return;
    }

    if (Number(datapost.price) < Number(datapost.priceDrop)) {
      setError({
        isError: true,
        msg: "Giá ưu đãi phải nhỏ hơn Giá gốc",
      });
      return;
    }
    setError({
      isError: false,
      msg: "",
    });
    const formPost = new FormData();
    if (datapost.fileImage) {
      formPost.append("file", datapost.fileImage);
    }
    formPost.append("title", datapost.name);
    formPost.append("descriptions", datapost.descriptions);
    if (datapost.content) {
      formPost.append(
        "content",
        datapost.content.replace(new RegExp(window.SERVER_URL, "g"), "")
      );
    }
    if (datapost.workCCS) {
      formPost.append("workCCS", datapost.workCCS);
    }
    if (datapost.productTypeId) {
      formPost.append("productTypeId ", datapost.productTypeId);
    }
    formPost.append("code", datapost.code);
    formPost.append("name", datapost.name);
    formPost.append("price", datapost.price);
    if (datapost.priceDrop) {
      formPost.append("priceDrop", datapost.priceDrop);
    }
    formPost.append("categoryId", datapost.categoryId);
    formPost.append("orderLink", datapost.orderLink);
    formPost.append("detailLink", datapost.detailLink);
    formPost.append("id", datapost.id);
    formPost.append("typeButton", datapost.typeButton);
    dispatch(editProduct(formPost));
  };

  const handleCancel = () => {
    dispatch(setOpenEditProduct({ isOpen: false, id: "" }));
  };
  const onCheck = (value) => {
    if (parseInt(value) === 1) {
      setDataPost({ ...datapost, typeButton: parseInt(value) });
      setValueCheck(value);
    } else {
      setDataPost({ ...datapost, orderLink: "", typeButton: parseInt(value) });
      setValueCheck(value);
    }
  };
  return (
    <>
      <Modal
        maskClosable={false}
        className="wrapperModalPostNews"
        title={t("Chỉnh sửa sản phẩm")}
        centered
        width={1300}
        open={isOpenModalEdit}
        onCancel={handleCancel}
        footer={[
          <BaseButton
            content={"Lưu"}
            typeBtn="btnOrange"
            icon={<IconSave />}
            width={96}
            handleClick={handleSave}
          />,
        ]}
      >
        <Row>
          <Col span={4}>
            <LabelInput text={"Tên sản phẩm"} />
          </Col>
          <Col span={20}>
            <InputText
              typeInput={"baseInput"}
              text={datapost.name}
              setText={(value) => setDataPost({ ...datapost, name: value })}
              placeholder={"Nhập tên sản phẩm"}
            />
          </Col>
        </Row>
        <Row style={{ margin: "1.5rem 0" }}>
          <Col span={4}>
            <LabelInput text={"Mô tả"} />
          </Col>
          <Col span={20}>
            <InputText
              typeInput={"baseInput"}
              text={datapost.descriptions}
              setText={(value) =>
                setDataPost({ ...datapost, descriptions: value })
              }
              placeholder={"Nhập mô tả"}
            />
          </Col>
        </Row>

        <Row style={{ margin: "1.5rem 0" }}>
          <Col span={4}>{/* <LabelInput text={"Link đặt mua"} /> */}</Col>
          <Col span={20}>
            <Checkbox.Group
              style={{
                width: "100%",
                display: "flex",
                alignItems: "center",
              }}
              value={valueCheck}
            >
              <Col span={3}>
                <Checkbox
                  value={"1"}
                  checked={datapost.typeButton === 1 ? true : false}
                  onClick={() => onCheck("1")}
                >
                  Nút đặt mua
                </Checkbox>
              </Col>
              <Col span={10}>
                <InputText
                  width={293}
                  text={datapost.orderLink}
                  setText={(value) =>
                    setDataPost({ ...datapost, orderLink: value })
                  }
                  style={{ width: "291px" }}
                  placeholder={"Nhập link đặt mua sản phẩm"}
                  typeInput={`${
                    !datapost.orderLink &&
                    error.isError &&
                    parseInt(datapost.typeButton) === 1
                      ? "checkEmptyText baseInput"
                      : "baseInput"
                  }`}
                />
              </Col>
              <Col span={4}>
                <Checkbox
                  checked={datapost.typeButton === 2 ? true : false}
                  value={"2"}
                  onClick={() => onCheck("2")}
                >
                  Nút liên hệ
                </Checkbox>
              </Col>
            </Checkbox.Group>
          </Col>
        </Row>
        <Row style={{ margin: "1.5rem 0" }}>
          <Col span={4}>
            <LabelInput text={"Link chi tiết"} />
          </Col>
          <Col span={20}>
            <InputText
              text={datapost.detailLink}
              setText={(value) =>
                setDataPost({ ...datapost, detailLink: value })
              }
              placeholder={"Nhập link chi tiết sản phẩm"}
              typeInput={`${
                !datapost.detailLink && error.isError
                  ? "checkEmptyText baseInput"
                  : "baseInput"
              }`}
            />
          </Col>
        </Row>
        <Row justify={"end"} style={{ position: "relative" }}>
          <Col span={20}>
            <Row justify={"space-between"} style={{ width: "100%" }}>
              <Col span={12}>
                <Row style={{ width: "100%" }}>
                  <Col span={7}>
                    <span className="label">{t("Ảnh sản phẩm")}:</span>
                  </Col>
                  <Col span={15}>
                    <UpImageEdit
                      setImage={setImage}
                      width={"20.7rem"}
                      height={"237px"}
                      accept={".png, .jpg, .jpeg, .gif"}
                      image={image}
                      setFile={(value) =>
                        setDataPost({ ...datapost, fileImage: value })
                      }
                      widthImage={207}
                      heightImage={237}
                      url={datapost.url}
                      style={
                        (!image && error.isError) ||
                        error.msg === "File có định dạng .jpeg, .png, .gif" ||
                        error.msg === "Dung lượng ảnh phải nhỏ hơn < 2MB" ||
                        error.msg === "Kích thước ảnh không hợp lệ"
                          ? { border: "1px solid red" }
                          : null
                      }
                    />
                    {/* <UploadImage
                      url={datapost.url}
                      setImage={(e) => setImage(e)}
                    /> */}
                  </Col>
                </Row>
              </Col>
              <Col span={12}>
                <Row>
                  <Col span={8}>
                    <LabelInput text={"Giá gốc"} />
                  </Col>
                  <Col span={16}>
                    <InputText
                      maxLength={155}
                      placeholder={"Nhập giá gốc"}
                      setText={(value) =>
                        setDataPost({ ...datapost, price: value })
                      }
                      text={datapost.price}
                      typeInput="baseInput"
                    />{" "}
                  </Col>
                </Row>
                <Row style={{ margin: "1.5rem 0" }}>
                  <Col span={8}>
                    <LabelInput text={"Giảm ưu đãi"} />
                  </Col>
                  <Col span={16}>
                    <InputText
                      maxLength={8}
                      placeholder={"Nhập giá ưu đãi"}
                      setText={(value) =>
                        setDataPost({ ...datapost, priceDrop: value })
                      }
                      text={datapost.priceDrop}
                      typeInput="baseInput"
                    />
                  </Col>
                </Row>

                <Row style={{ margin: "1.5rem 0" }}>
                  <Col span={8}>
                    <LabelInput text={"Mã sản phẩm"} />
                  </Col>
                  <Col span={16}>
                    <InputText
                      maxLength={13}
                      placeholder={"Nhập mã sản phẩm"}
                      setText={(value) =>
                        setDataPost({ ...datapost, code: value })
                      }
                      text={datapost.code}
                      typeInput="baseInput"
                    />
                  </Col>
                </Row>
                <Row style={{ margin: "1.5rem 0" }}>
                  <Col span={8}>
                    <LabelInput text={"Nhóm sản phẩm"} />
                  </Col>
                  <Col span={16}>
                    <InputText
                      maxLength={13}
                      placeholder={"Nhập mã nhóm sản phẩm"}
                      setText={(value) =>
                        setDataPost({ ...datapost, productTypeId: value })
                      }
                      text={datapost.productTypeId}
                      typeInput={` "baseInput"
                      }`}
                    />
                  </Col>
                </Row>
                <Row style={{ margin: "1.5rem 0" }}>
                  <Col span={8}>
                    <LabelInput text={"Mã chia việc CCS"} />
                  </Col>
                  <Col span={16}>
                    <InputText
                      maxLength={13}
                      placeholder={"Nhập mã chia việc CCS"}
                      setText={(value) =>
                        setDataPost({ ...datapost, workCCS: value })
                      }
                      text={datapost.workCCS}
                      typeInput={` "baseInput"
                      }`}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>{" "}
          {error.isError ? (
            <small className="msgError" style={{ bottom: -50, left: 220 }}>
              {t(error.msg)}
            </small>
          ) : null}
        </Row>
      </Modal>
    </>
  );
};

export default ModalEditProduct;
